// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".retail_container__pCs6a > *:not( :last-child ) {\n\n    margin-bottom: 1rem;\n\n}", "",{"version":3,"sources":["webpack://./src/Pages/Shop/Markups/retail/retail.module.css"],"names":[],"mappings":"AAAA;;IAEI,mBAAmB;;AAEvB","sourcesContent":[".container > *:not( :last-child ) {\n\n    margin-bottom: 1rem;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "retail_container__pCs6a"
};
export default ___CSS_LOADER_EXPORT___;
